var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64344 10C5.52988 10.3636 5.48164 10.7492 5.50626 11.1392V20C5.50626 20.7401 5.73597 21.4265 6.12797 21.9919C6.08607 21.9972 6.04336 22 6 22H3C2.44772 22 2 21.5523 2 21V11C2 10.4477 2.44772 10 3 10H5.64344Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 16H16C15.4477 16 15 16.4477 15 17V21C15 21.5523 15.4477 22 16 22H21C21.5523 22 22 21.5523 22 21V17C22 16.4477 21.5523 16 21 16H20.75V15C20.75 14.0335 19.9665 13.25 19 13.25H18C17.0335 13.25 16.25 14.0335 16.25 15V16ZM17.75 15C17.75 14.8619 17.8619 14.75 18 14.75H19C19.1381 14.75 19.25 14.8619 19.25 15V16H17.75V15Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7784 13.3129C21.2081 12.3758 20.1771 11.75 19 11.75H18C16.2614 11.75 14.8417 13.1151 14.7543 14.832C14.0047 15.2636 13.5 16.0729 13.5 17V21C13.5 21.3556 13.5742 21.6938 13.708 22H9.00626C7.90169 22 7.00626 21.1046 7.00626 20V11.0844C6.95973 10.5506 7.17448 10.0271 7.58339 9.67749L9.03367 8.43769C9.70656 7.86246 10.3539 7.24017 10.7726 6.46262C11.0591 5.93045 11.2814 5.36723 11.434 4.78374L11.9135 2.94989C12.0063 2.59473 12.2569 2.29611 12.5994 2.13239C12.9105 1.98365 13.2707 1.95918 13.6007 2.06435L13.7469 2.11093C14.2929 2.28495 14.7081 2.71364 14.8478 3.24752C15.0163 3.892 15.0473 4.56435 14.9387 5.22142L14.2708 9.26598C14.187 9.77328 14.5811 10.2342 15.0988 10.2342H20.3214C21.3627 10.2342 22.1526 11.1662 21.975 12.1852L21.7784 13.3129Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike2);
export default __webpack_public_path__ + "static/media/like-2.60697b794c4844b199519c1017e75abf.svg";
export { ForwardRef as ReactComponent };